import { PhasePlaceholder } from '../components/PhasePlaceholder.js';

export function InvestmentDayPage() {
  return (
    <PhasePlaceholder
      title="Befektetési nap"
      phase={5}
      criteria={[
        'Megadott összeg elosztása a target_weight szerint, aktuális árakkal.',
        'Instrumentumonkénti összeg és darabszám javaslat.',
        'A javaslat egy kattintással tervezett tranzakcióként menthető.',
      ]}
    />
  );
}
